import React, { Component } from "react";
import classnames from "classnames";

import * as styles from "./Label.scss";

export interface ILabelProps {
    position: "top" | "left" | "bottom" | "right";
    active: boolean;
    children?: React.ReactNode;
}

export class Label extends Component<ILabelProps> {
    public render() {
        const { position, active, children } = this.props;
        return (
            <div
                className={classnames(
                    styles.label,
                    styles[position],
                    active && styles.active,
                )}
            >
                {children}
            </div>
        );
    }
}
